const dictionary = {
  en: {
    messages: {
      required: () => 'This is a required field.',
      email: () => 'The email field must be a valid email.'
    },
    custom: {
      'nameOnCard': {
        regex: () => 'The name on card can contain only alphabetical letters and these characters: ~ ^ & * ( ) - [ ] \\.',
        alpha_spaces: () => 'No numbers allowed for this field.'
      },
      'accountConfirm': {
        confirmed: () => 'The account numbers entered do not match. Please try again.'
      },
      'routingConfirm': {
        confirmed: () => 'The routing numbers entered do not match. Please try again.'
      },
      'routingNumber': {
        max: () => 'The routing number must be 9 digits. Please try again.',
        min: () => 'The routing number must be 9 digits. Please try again.'
      },
      'address-zip': {
        digits: () => 'The Zipcode must be 5 digits.',
        numeric: () => 'The Zipcode can only contain numeric characters.'
      },
      'mobile-phone': {
        min: () => 'The phone number entered is an invalid format. Please try again.'
      },
      'password': {
        min: () => 'The password fields entered are not in a valid format. Passwords must be between 8-14 characters long and are case sensitive. Please try again.',
        max: () => 'The password fields entered are not in a valid format. Passwords must be between 8-14 characters long and are case sensitive. Please try again.'
      },
      'username': {
        min: () => 'The username you enter must be at least 6 characters long. Please re-enter your username again.',
        max: () => 'The username you enter must be less than 60 characters long. Please re-enter your username again.',
        hasSpecialCharacterValidator: () => 'The username can contain only these special characters: ! # $ % * / ? I ^ { } ` ~ & \' + - = _ .- @ - .. Please re-enter your username again.'
      },
      'confirmPassword': {
        confirmed: () => 'The passwords do not match. Please try again.',
        min: () => 'The confirm password field must be at least 8 characters.',
        max: () => 'The confirm password field may not be greater than 14 characters.'
      }
    }
  }
}

export default dictionary



// WEBPACK FOOTER //
// ./src/assets/validation-messages.js